import { render, staticRenderFns } from "./AudioData.vue?vue&type=template&id=0fceedde&scoped=true"
import script from "./AudioData.vue?vue&type=script&lang=js"
export * from "./AudioData.vue?vue&type=script&lang=js"
import style0 from "./AudioData.vue?vue&type=style&index=0&id=0fceedde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fceedde",
  null
  
)

export default component.exports